import { supabase } from './supabase'

/**
 * Hesap silme talebi (Ayarlar > Hesabım, 23 Eki 2026). "account" fonksiyonu
 * şifreyi yeniden doğruluyor, kurumu kapatıyor ve bütün hesapları kilitliyor;
 * kalıcı silme 30 gün sonra (supabase/hesap-silme.sql).
 */
export async function requestAccountDeletion(tenantId: string, password: string): Promise<void> {
  if (!supabase) throw new Error('Bağlantı yok.')
  const { data, error } = await supabase.functions.invoke('account', {
    body: { action: 'request-deletion', tenantId, password },
  })
  // Şifre yanlışsa fonksiyon 403 dönüyor; mesajı gövdeden okumak gerek.
  if (error) {
    const ctx = (error as { context?: Response }).context
    const body = ctx && typeof ctx.json === 'function' ? await ctx.json().catch(() => null) : null
    throw new Error(body?.error ? String(body.error) : 'Gönderilemedi. İnternet bağlantınızı kontrol edin.')
  }
  if (data?.error) throw new Error(String(data.error))
}
